var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhonePrimary = function SvgPhonePrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0093DD",
    d: "M21.739 16.414A5.275 5.275 0 0 1 16.5 21C9.056 21 3 14.944 3 7.5A5.274 5.274 0 0 1 7.586 2.26a1.5 1.5 0 0 1 1.558.893l1.98 4.42v.011A1.5 1.5 0 0 1 11.005 9l-.053.072L9 11.386c.702 1.427 2.195 2.906 3.64 3.61l2.282-1.941a1.501 1.501 0 0 1 1.492-.184l.013.005 4.416 1.98a1.5 1.5 0 0 1 .896 1.558"
  })));
};
export default SvgPhonePrimary;